<!-- <p>calendar-container works!</p> -->
<div
  [ngClass]="{
    'calendar-container-component':
      screenSize == ScreenType.Desktop || screenSize == ScreenType.Mobile,
    'calendar-container-component-tablet': screenSize == ScreenType.Tablet
  }"
>
  <app-visitor-calendar-container></app-visitor-calendar-container>
</div>

<br />
<br />
<br />
<br />
